
import { IYoelloTheme } from "../../yoello-lib/modules/themes/IYoelloTheme";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from "@material-ui/core/styles/withStyles";


function setItemFontStyles(fontFamily: string,
  fontStyle: string,
  fontWeight: any,
  fontSize: string,
  lineHeight: string,
  color: string): CSSProperties {
  return {
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    fontSize: fontSize,
    lineHeight: lineHeight,
    color: color,
  }
}
export const useStyles:any = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    root:{
      height:"100%",
      "&>header":{
        padding:"0.938rem 0.9375rem",
        height:"5rem",
        borderBottom:"1px solid #E8EAF4",
        display:"flex",
        justifyContent:"space-between",
        alignItems:"center",
        "&>div:first-child":{
          "&>svg:first-child":{
            color:"#737FA4",
            margin:"1rem",
            cursor:"pointer"
          },
          display:"flex",
          justifyContent:"space-between",
          alignItems:"center", 
          
        },
        "&>div:last-child":{
          "&>div:first-child>button":{
            background:"#455681"
          },
          display:"flex",
          justifyContent:"space-between",
          alignItems:"center",
        }
      }
    },
    title: {
      marginLeft: "0.5rem",
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "0.875rem",
      color: "#455681",
      display: "flex",
      justifyContent: "center",
      lineHeight: "0.875rem",
      "@media (max-width: 600px)": {
        display: "none",
      },
    },
    wrapper:{
      height:"calc(100vh - 18rem)",
      overflowY:"auto"
    },
    dialogContainer: {
      "& .MuiDialog-paperWidthMd": {
        maxWidth: "56.25rem!important",
        overflow:"hidden!important",
        "& >div":{
          overflow:"auto!important",
          padding:"2.5rem 3rem!important"
        }
      },
      "& header":{
        marginBottom:"0!important"
      }
    },
    orderDetailsModalContainer: {
      "& .MuiDialog-paperWidthMd": {
        "@media only screen and (min-width: 768px)": {
          width: "68.9375rem !important",
          minWidth: "68.9375rem!important;"
        },
      },
     
    },
    columnsHeader:{
      alignItems: "center",
      width:"100%",
      display: "grid",
      marginBottom:"1.25rem",
      gridTemplateColumns:"30% 70%",
      padding:"0 4.375rem",
      "& >div":{
        "& >span":{
          ...setItemFontStyles("Open Sans","normal","normal","0.9rem","1.25rem","#8D98B7"),
          display: "flex",
          justifyContent:"start",
          alignItems: "center",
        }
      },
      "@media only screen and (max-width: 425px)": {
        display:"none"
      },
    },
    listItem:{
      padding:"1.875rem 4.375rem",
      background:"#FFFFFF",
      borderRadius:"1rem",
      marginBottom:"1.25rem",
      display:"grid",
      gridTemplateColumns:"30% 70%",
      cursor:"pointer",
      "& >div:first-child":{
        ...setItemFontStyles("Open Sans","normal", 600, "1.063rem","1.438rem","#212121"),
        display:"flex",
        alignItems:"center"
      },
      "& >div:last-child":{
        "& >span":{
          ...setItemFontStyles("Open Sans","normal", 400, "0.875rem","1.188rem","#455681"),
          padding:"0.5rem 0.625rem",
          background:"#F3F4F9",
          borderRadius:"0.5rem",
          margin:"0.313rem",
          display:"inline-block"
        }
      },
      "@media only screen and (max-width: 425px)": {
        display:"flex",
        flexDirection:"column",
        "& >div:first-child":{
          marginBottom:".5rem"
        },
        "& >div:last-child":{
          "& >span":{
            marginLeft:"0!important",
          }
        },
    },
    },
    controlers:{
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
      marginBottom:"2.5rem",
      "&>div:last-child>div>div":{
        paddingBottom:"0!important"
      },
      "& .search":{
        minWidth:"23.75rem",
        "@media only screen and (max-width: 768px)": {
            minWidth:"15.75rem!important",
        },
      },
     
    },
    container: {
      padding:"1.875rem 4.6875rem",
      height:"calc(100% - 5rem)",
     
    },
    listWrapper:{
      padding:"0 2.8125rem"
    },
    settingsWrapper:{
      display:"flex",
      height:"100%",
      padding:"0 2.3125rem",
      "@media (max-width: 1000px)": {
        flexDirection: "column!important",
      },
    },
    areasWrapper:{
      padding:"2.5rem 3.75rem"
    },
    content: {
      flex: 1,
      height:"100%",
      overflowY:"auto",
      padding:"0 .5rem"
    },
    emptyList:{
      width: "100%",
      textAlign: "center",
      marginTop:"10rem"
    },
    textWrapper: {
      padding: "24px"
    },
  }),
);